const OriginIcon = '/assets/traveltur/Home/Traveltur-Website-Home-SearchBar-OriginIcon.svg';
const DestinationIcon =
  '/assets/traveltur/Home/Traveltur-Website-Home-SearchBar-DestinationIcon.svg';
const BuyIconWhite = '/assets/traveltur/Home/SanAntonio-Website-Home-NavBar-BuyTicket.svg';
const CancelIconWhite = '/assets/traveltur/Home/SanAntonio-Website-Home-NavBar-CancelTicket.svg';
const CalendarIcon = '/assets/traveltur/Home/SanAntonio-Website-Home-NavBar-DateIcon.svg';
const HeaderLogo = '/assets/traveltur/Home/SanAntonio-Website-Logo-Header.svg';
const Support = '/assets/traveltur/Contact/Traveltur-Website-Contact-Phone.png';
const ContactEmail = '/assets/traveltur/Contact/Traveltur-Website-Contact-Mail.png';
const ContactLocation = '/assets/traveltur/Contact/Traveltur-Website-Contact-Office.png';
const fbIcon = '/assets/traveltur/Contact/SanAntonio-Website-Contact-SocialMedia-Facebook.svg';
const TelephoneIconFooter = '/assets/traveltur/Home/SanAntonio-Website-Home-Footer-Telephone.svg';
const EmailIconFooter = '/assets/traveltur/Home/SanAntonio-Website-Home-Footer-Email.svg';
const FbInActive = '/assets/traveltur/Contact/Traveltur-Website-Contact-Facebook.png';
const FbActive = '/assets/traveltur/Contact/Traveltur-Website-Contact-Facebook.png';
const InstaInActive = '/assets/traveltur/Contact/Traveltur-Website-Contact-Instagram.png';
const InstaActive = '/assets/traveltur/Contact/Traveltur-Website-Contact-Instagram.png';
const Facebook = '/assets/traveltur/Contact/Facebook.svg';
const Instagram = '/assets/traveltur/Contact/Instagram.svg'
// -----------------------------

const DestinationBanner =
  '/assets/traveltur/Destinations/SanAntonio-Website-Destinations-Banner.jpg';
const ContactUsBanner = '/assets/traveltur/Contact/SanAntonio-Website-Contact-Banner.jpg';
const TermsBanner =
  '/assets/traveltur/TermsAndConditions/SanAntonio-Website-TermsAndConditions-Banner.jpg';
const OfficeBanner = '/assets/traveltur/Offices/SanAntonio-Website-Offices-Banner.jpg';
const FooterLogo = '/assets/tepual/general/Footer-BusesTepualLogo.svg';
const ContactBg = '/assets/tepual/home/home-background.jpg';
const PopupIcon = '/assets/andimar/Andimar-PopUp.jpg';

const ContactIcon = '/assets/andimar/contact-by/contact.svg';
const EmailIcon = '/assets/andimar/contact-by/email.svg';
// const TelephoneIcon = '/assets/andimar/contact-by/telephone.svg';
const TelephoneIcon = '/assets/traveltur/Home/SanAntonio-Website-Home-Footer-Telephone.svg';





const SearchIcon = '/assets/andimar/navbar-searchIcon.svg';
const BlueArrow = '/assets/andimar/favoriteDestinations/andimar-blue-arrow.svg';
const ClockIcon = '/assets/andimar/favoriteDestinations/andimar-clock.svg';
const FleetBanner = '/assets/andimar/fleet/fleet-banner.jpg';
const AboutBanner = '/assets/traveltur/About/About-Banner.png';
const NorteBanner = '/assets/traveltur/North/Norte-banner.png';
const FleetTv = '/assets/andimar/fleet/18.svg';
const FleetToilet = '/assets/andimar/fleet/19.svg';
const FleetAc = '/assets/andimar/fleet/20.svg';
const FleetSnacks = '/assets/andimar/fleet/21.svg';
const FleetBed = '/assets/andimar/fleet/22.svg';
const AmenitiesLeftImage = '/assets/traveltur/About/about-left-img.png';
const AmenitiesRightImage = '/assets/traveltur/North/norte-right-img.png';
const BuyIconBlue = '/assets/andimar/buy-ticket-blue.svg';
const CancelIconBlue = '/assets/andimar/cancel-ticket-blue.svg';
const TelephoneWhite = '/assets/andimar/contact-by/telephone-white.svg';
const EmailWhite = '/assets/andimar/contact-by/email-white.svg';
const checkboxIcon = '/static/images/icons/AndimarWebsite-Checkbox.png';
const animation = '/static/images/animations/animation.gif';

const pnr = '/assets/traveltur/Home/WhereToFindMyPNR.jpg';
const close = '/assets/viatur/icons/close.svg';

// const userIcon = '/static/images/user_red_dot.svg';

const success = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess =
  '/assets/traveltur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/traveltur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

const ammenity1 = '/assets/traveltur/Home/amenity-1.svg';
const ammenity2 = '/assets/traveltur/Home/amenity-2.svg';
const ammenity3 = '/assets/traveltur/Home/amenity-3.svg';

const Office1 = '/assets/traveltur/Offices/SanAntonio-Website-Offices-Arica.png';
const Office2 = '/assets/traveltur/Offices/SanAntonio-Website-Offices-Iquique.png';

//  pet seat 
const petseatref = '/assets/traveltur/pet/Traveltur-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).png';
const petseatModal = '/assets/traveltur/pet/PopUp-Traveltur.png';
const petfilteroff = '/assets/traveltur/pet/PetsOnBoard-Button-Filter_Off.png';
const petfilteron = '/assets/traveltur/pet/PetsOnBoard-Button-Filter_on.png';

const operatorPay = '/assets/traveltur/travelturpay.png'
const ServiceBanner = '/assets/traveltur/services/servicios-especiales.webp'

const OriginoIcon = '/assets/traveltur/services/origino.svg'
const DestinationoIcon = '/assets/traveltur/services/destino.svg'
const DateIcon= '/assets/traveltur/services/datum.svg'


const BookingActive = '/assets/tepual/home/BuyTicketIcon-Inactive.svg';
const BookingInActive = '/assets/tepual/home/BuyTicketIcon-Inactive.svg';
const CancelActive = '/assets/traveltur/Home/New-searchbar_anular.png';
const CancelInActive = '/assets/traveltur/Home/New-searchbar_anular.png';



const ChangeTicketActive = '/assets/traveltur/Home/New-searchbar_Confirmar.png';
const ChangeTicketInActive = '/assets/traveltur/Home/New-searchbar_Confirmar.png';
const ConfirmTicketActive = '/assets/traveltur/Home/New-searchbar_Confirmar.png';
const ConfirmTicketInActive = '/assets/traveltur/Home/New-searchbar_Confirmar.png';
const CuponeraActive = '/assets/traveltur/Home/New-searchbar_Cuponera.png';
const CuponeraInActive = '/assets/traveltur/Home/New-searchbar_Cuponera.png';

// 
const travelturIcons = [
  // { icon: userIcon, name: 'userIcon' },
		{ icon: OriginoIcon, name: 'OriginoIcon' },
		{ icon: DestinationoIcon, name: 'DestinationoIcon' },
		{ icon: DateIcon, name: 'Calendar' },
		{ icon: ServiceBanner, name: 'ServiceBanner' },
  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },

  { icon: ChangeTicketActive, name: 'CTA' },
  { icon: ChangeTicketInActive, name: 'CTIA' },
  { icon: ConfirmTicketActive, name: 'CCA' },
  { icon: ConfirmTicketInActive, name: 'CCIA' },
  { icon: CuponeraActive, name: 'CUA' },
  { icon: CuponeraInActive, name: 'CUIA' },


  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: ContactBg, name: 'ContactBg' },
  { icon: close, name: 'close' },

  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: CalendarIcon, name: 'Calendar' },
  { icon: SearchIcon, name: 'Search' },
  { icon: PopupIcon, name: 'Popup' },
  { icon: DestinationBanner, name: 'DestinationBanner' },
  { icon: ContactIcon, name: 'ContactIcon' },
  { icon: TelephoneIcon, name: 'TelephoneIcon' },
  { icon: TelephoneIconFooter, name: 'TelephoneIconFooter' },
  { icon: EmailIconFooter, name: 'EmailIconFooter' },
  { icon: BlueArrow, name: 'BlueArrow' },
  { icon: ClockIcon, name: 'ClockIcon' },
  { icon: FleetBanner, name: 'FleetBanner' },
  { icon: AboutBanner, name: 'AboutBanner' },
  { icon: NorteBanner, name: 'NorteBanner' },
  { icon: FleetTv, name: 'FleetTv' },
  { icon: FleetToilet, name: 'FleetToilet' },
  { icon: FleetAc, name: 'FleetAc' },
  { icon: FleetSnacks, name: 'FleetSnacks' },
  { icon: FleetBed, name: 'FleetBed' },
  { icon: AmenitiesLeftImage, name: 'AmenitiesLeftImage' },
  { icon: AmenitiesRightImage, name: 'AmenitiesRightImage' },
  { icon: pnr, name: 'pnr' },
  { icon: EmailIcon, name: 'EmailIcon' },
  { icon: BuyIconWhite, name: 'BuyIconWhite' },
  { icon: BuyIconBlue, name: 'BuyIconBlue' },
  { icon: CancelIconWhite, name: 'CancelIconWhite' },
  { icon: CancelIconBlue, name: 'CancelIconBlue' },
  { icon: TelephoneWhite, name: 'TelephoneWhite' },
  { icon: EmailWhite, name: 'EmailWhite' },
  { icon: Facebook, name: 'Facebook' },
  { icon: Instagram, name: 'Instagram' },
  { icon: checkboxIcon, name: 'Checkbox' },
  { icon: animation, name: 'animation' },
  { icon: ammenity1, name: 'ammenity1' },
  { icon: ammenity2, name: 'ammenity2' },
  { icon: ammenity3, name: 'ammenity3' },
  { icon: Support, name: 'Support' },
  { icon: ContactEmail, name: 'ContactEmail' },
  { icon: ContactLocation, name: 'ContactLocation' },
  { icon: fbIcon, name: 'fbIcon' },
  { icon: ContactUsBanner, name: 'ContactUsBanner' },
  { icon: TermsBanner, name: 'TermsBanner' },
  { icon: Office1, name: 'Office1' },
  { icon: Office2, name: 'Office2' },
  { icon: OfficeBanner, name: 'OfficeBanner' },
  { icon: FbInActive, name: 'FbInActive' },
  { icon: FbActive, name: 'FbActive' },
  { icon: InstaInActive, name: 'InstaInActive' },
  { icon: InstaActive, name: 'InstaActive' },


  //  pet seat 
  { icon: petseatref, name: 'petseatref' },
  { icon: petseatModal, name: 'petseatModal' },
  { icon: petfilteron, name: 'petfilteron' },
  { icon: petfilteroff, name: 'petfilteroff' },

  { icon: operatorPay, name: 'operatorPay' },


];

export default travelturIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/travelturIcons.js